// import ModalForm from "./Form";
import InvoiceHistoryTableForm from "./TableForm";
import InvoiceHistoryApproveForm  from "./ApproveForm";
import InvoiceHistoryRejectForm  from "./RejectForm";
import {
    INVOICE_HISTORY_V2,
    DATATABLE_EXPORT,
} from "../../../../Config/ApiUrl";
// import * as actions from "../../../../Config/ApiUrl";

export const Schema = {
    components: { InvoiceHistoryTableForm,InvoiceHistoryApproveForm,InvoiceHistoryRejectForm },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            Endpoint: INVOICE_HISTORY_V2,
            tableId: "invoice-history-table",
            formId: "invoice-history-table-form",
            formIdApprove: "invoice-history-approve-form",
            formIdReject: "invoice-history-reject-form",
            rowData: {},
            tableColumns: [
                {
                    title: "CLC ID Number",
                    type: "custom-html",
                    key: "lead",
                    modifier: (value) => {
                        return value?.student_id || value?.lead_id_number || value?.clc_id_number || "-";
                    }
                },
                {
                    title: "Student Name",
                    type: "custom-html",
                    key: "lead",
                    modifier: (value) => {
                        return value?.full_name;
                    }
                },
                {
                    title: "Request By",
                    type: "custom-html",
                    key: "request_user_id",
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            return value.full_name
                        } else {
                            return ""
                        }
                    }
                },
                {
                    title: "Request Date",
                    type: "text",
                    key: "request_date",
                },
                {
                    title: "Invoice Request ID",
                    type: "text",
                    key: "request_no",
                },
                {
                    title: "Semester",
                    type: "custom-html",
                    key: "academic_calendar",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.academic_calendar_name : '-'
                    },
                },
                {
                    title: "Invoice Status",
                    type: "custom-html",
                    key: "status",
                    isVisible: true,
                    modifier: (value, rowData) => {
                        const dueDate = rowData.due_date;
                        const today = new Date().toISOString().slice(0, 10);
                        if (value) {
							let ClassName = "danger";
                            let status = rowData.status;
                            if (value === "Waiting Approval AC") {
								ClassName = `primary`;
                                status = 'Awaiting Approval';
							} else if (value === "Paid") {
								ClassName = `success`;
							} else if (value === "UnPaid") {
								ClassName = `danger`;
							} else if (value === "Cancelled" || value === "Deleted"  || value === "Rejected" || value === "Rejected By AC") {
								ClassName = `danger`;
                            } else if(dueDate < today) {
                                status = 'Voided';
								ClassName = `danger`;
							} else if (value === "Waiting Approval Finance" && rowData.invoice_payment_status== 0) {
								ClassName = `primary`;
                                status = 'InProgress';
							}else if (value === "Waiting Approval Finance" && rowData.invoice_payment_status== 1) {
								ClassName = `primary`;
                                status = 'Payable';
							}  else if (value === "Requested") {
								ClassName = `warning`;
							} else if (value === "Processed") {
								ClassName = `secondary`;
							} else if (value === "Invoiced") {
								ClassName = `primary`;
							} 
                                            
                            let statusHtml = `
                                        <div class="text-center">
                                            <span class="badge badge-sm badge-pill badge-${ClassName}">${status}</span>`;
                            if(value == 'UnPaid'){
                                statusHtml +=`<br>${rowData.approval_note}`;
                            }
                            
                            if (value === "Waiting Approval Finance" && rowData.invoice_payment_status == 1 && dueDate >= today && value != "Cancelled") {
                                    statusHtml += `
                                    <div style="margin-top: 5px;">
                                        <button class="btn btn-success btn-sm" title="Approve"  onclick="window.__approveInvoice('${rowData.id}')"><i class="fa fa-check"></i></button>
                                        <button class="btn btn-danger btn-sm" title="Reject"  onclick="window.__rejectInvoice('${rowData.id}')"><i class="fa fa-times"></i></button>
                                    </div>
                                    `;
                                }

                            statusHtml += `</div>`; 

                            return statusHtml;
                        }
                    },
                },
                {
                    title: "Completed By",
                    type: "text",
                    key: "completed_user_id",
                },
                {
                    title: "Action",
                    type: "action",
                },
                {
                    title: "Fees Notice ID",
                    type: "text",
                    key: "invoice_no",
                },
                {
                    title: "Print Date",
                    type: "text",
                    key: "request_print_date",
                },
                {
                    title: "Due Date",
                    type: "text",
                    key: "due_date",
                },
            ],
            actionObj: {
                title: this.$t("action"),
                type: "action2",
            },
            options: {
                name: "InvoiceHistoryTable",
                url: INVOICE_HISTORY_V2,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t("edit"),
                        icon: "edit",
                        type: "page",
                        url: (rowData) => 
                            rowData.lead?.status_id === 1 
                                ? `transaction/profile-lead/invoice/invoice-request-v2/${rowData.id}` 
                                : `transaction/profile-student/invoice/invoice-request-v2/${rowData.id}`,
                        target: "", // _blank to open newtab
                        uniqueKey: (rowData) => rowData.id,
                        disabled: (rowData) => {
                            return !rowData.lead || this.isButtonDisabled(rowData);
                        }
                    },
                    {
                        title: 'View',
                        icon: "eye",
                        type: "page",
                        disabled: (rowData) => this.isButtonDisabled(rowData)
                    },
                    {
                        title: 'Print',
                        icon: "file",
                        type: "page",
                        disabled: (rowData) => this.isButtonDisabled(rowData)
                    },
                ],
                // actions2: [
                //     {
                //         title: this.$t("delete"),
                //         icon: "trash",
                //         type: "none",
                //         component: "app-confirmation-modal",
                //         modalId: "demo-delete",
                //         disabled: (rowData) => this.isButtonDisabled(rowData)
                //     },
                // ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {
        isButtonDisabled(rowData) {
            return rowData.status?.toLowerCase() === "deleted" || (rowData.deduction_type?.toLowerCase() === 'voucher');
        }
    },
};
